import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ISearchResult } from 'src/app/models/search/search';
import { AuthorizationService, CommunicationService, CoreService, DocumentService, LoaderService, LoggingService, PortalService, RoutingService } from 'src/app/services';
import { NavigatesearchService } from 'src/app/services/navigatesearch.service';
import { Router } from '@angular/router';
import { IAssetStatus, IDocumentView, IPortalConfig, ITabs, IViewerParams, NotificationType, PlatForm } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { DocumentType, ViewerContentType } from 'src/app/models';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { HeaderComponent } from 'src/app/modules/layout/header/header.component';
import { Helpers } from 'src/app/helpers';
import moment from 'moment';
import { TrainingService } from 'src/app/services/training.service';
import { Actions, AssetTracking } from 'src/app/models/document/assettracking';

@Component({
    selector: 'app-appsearch',
    templateUrl: './appsearch.component.html',
    styleUrls: ['./appsearch.component.scss'],
    standalone: false
})
export class AppsearchComponent implements OnInit {
  PortalInfo: IPortalConfig;

  @Input() searchText!: string;
  searchResult: ISearchResult[] = [];
  SiteID !: number;
  placeInRegDocEnabled: boolean = true;
  sponsor !: string;
  portal !: string;
  cdnEndPoint = environment.cdnEndPoint;
  sub: any;
  portalId! : number;
  isStudyStat: boolean = Helpers.getPlatformId() == PlatForm.StudyStat; 
  constructor(
    public navigatesearchService: NavigatesearchService,
    private loggingService: LoggingService,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private portalService: PortalService,
    private router: Router,
    private documentService: DocumentService,
    private modelDialogService: NgbModal,
    private authorizationService: AuthorizationService,
    private communicationService: CommunicationService,
    private routingService: RoutingService,
    private notificationService: TopNotificationService,
    private trainingService: TrainingService,
    private coreService: CoreService
  ) {
    this.placeInRegDocEnabled = this.authorizationService.isNavigationOrFeatueAllowed("PlaceESafe");
    this.PortalInfo = this.portalService.portalConfiguation?.value!;
  }

  ngOnInit(): void {
    this.sponsor = <string>this.PortalInfo.SponsorName;
    this.SiteID = <number>this.PortalInfo.SiteId;
    this.portalId = <number>this.PortalInfo.PortalID;
    this.portal = <string>this.PortalInfo.PortalName;
    const _params = Helpers.toLowerQueryParams(this.activatedRoute.snapshot.queryParams);
    if (_params['q'] != undefined) {
      this.searchText = _params['q'];
      this.getSearch();
    }
    this.sub = this.navigatesearchService.getSearchString().subscribe((result: any) => {
      this.searchText = result;
      this.getSearch();
    });
  }
  ngOnDestroy(): void {
    $('.dropdown-menu.finduser-wrap').hide();
    $('.search-backdrop').hide();
    $("#searchByTxt").val('');
    this.sub.unsubscribe();
  }
  getSearch() {
    this.loggingService.Info(
      `<MedPoint.WebApp.TriPort.Shared.Search.getSearch> begins.`
    );   
    if (this.searchText != undefined && this.searchText != null && this.searchText != '') {
      $("#searchByTxt").val(this.searchText);
      this.loaderService.showLoader();
      this.navigatesearchService.Search(<number>this.PortalInfo.PortalID, this.searchText).then((data: any) => {
        if (data) {
          this.searchResult = data;
        }
        this.loggingService.Info(
          `<MedPoint.WebApp.TriPort.Shared.Search.getSearch> ends.`
        );
      }).finally(() => {
        this.loaderService.hideLoader();
      });
    }

    $('.dropdown-menu.finduser-wrap').show();
    $('.search-backdrop').hide();
  }

  onSearch(e:any){
    this.navigatesearchService.setSearchString(this.searchText);
  }
  
  openDocumentViewer(data: any) {
       this.loaderService.showLoader();
       this.documentService.getDocumentUrl(<string>this.PortalInfo.SponsorName, <number>this.PortalInfo.PortalID, data.PersonAssetGuid).then((result: IDocumentView) => {
         if (result.SuccessFlag) {
          const assetTracking = new AssetTracking();
          assetTracking.AssetId = data.AssetID;
          assetTracking.ActionId = Actions.View;
          this.insertAssetTracking(assetTracking);
           let params: IViewerParams = {
             DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
             ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
             DownloadCallbackFunction: "DownloadDocument",
             DownloadCallbackFunctionParam: data.PersonAssetGUID,
             Anontation: false,
             Download: data.IsDownloadable,
             Print: data.IsDownloadable
           };
           let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
           let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
           //let viewerOptions = `anontationaccess=${false}&downloadaccess=${data.IsDownloadable}&printaccess=${data.IsDownloadable}`
           //let CONTENTURL = environment.viewerAppUrl + 'viewer/index?' + (result.Type == "URL" ? 'document=' + encodeURIComponent(result.ViewingSessionID) : "viewingsessionid=" + result.ViewingSessionID) + "&dnCallbkFn=DownloadDocument&dnCallbkFnParam=" + data.PersonAssetGUID + viewerOptions;
           let tabData: ITabs = { AssetId: data.AssetID, DocumentType: DocumentType.Document, DocumentPath: result.DocumentPath, contentUrl: CONTENTURL, htmlContent: "", name: data.AssetName, PersonAssetGuid: data.PersonAssetGUID, PersonAssetId: data.PersonAssetID, showPlaceInRegDoc: data.IsDownloadable && this.placeInRegDocEnabled, showPrintButton: false, showSignButton: result.Status.toLowerCase() == 'click to sign', SusarAssetStatusId: 0, ViewerContentType: ViewerContentType.Document, viewerToken: queryParam ,EnableAIInsights: result.EnableAIInsights || false};
   
           let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
           modalInstance.componentInstance.tabData = tabData;
           modalInstance.result.then((result:any) => {
             this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {}, replaceUrl: true });
           });
           modalInstance.componentInstance.updateSignatureEvent.subscribe((receivedEntry: any) => {
             if (receivedEntry) {
               if (data.fromLink == undefined) {
                 this.documentService.getStatus(<string>this.PortalInfo.SponsorName, <number>this.PortalInfo.PortalID, data.PersonAssetGUID).then((statusResult: IAssetStatus) => {
                   data.Status = statusResult.Status;
                   data.DateCompleted = statusResult.DateCompleted;
                 });
               }
             }
           });
           if (data.fromLink == undefined) {
             this.documentService.getStatus(<string>this.PortalInfo.SponsorName, <number>this.PortalInfo.PortalID, data.PersonAssetGUID).then((statusResult: IAssetStatus) => {
               data.Status = statusResult.Status;
               data.DateCompleted = statusResult.DateCompleted;
             });
           }
         } else {
           let message = Helpers.getPlatformId() == PlatForm.StudyStat ? "You do not have permission to view this document." : "You don't have access to this document or document not found.";
           this.notificationService.showNotification(message, NotificationType.Error);
           this.loaderService.hideLoader();
         }
       }, (error) => {
         this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
         this.loaderService.hideLoader();
       }).finally(() => { });
     }

  OpenSafetyReportDocument(Name: any, PersonAssetID: any, AssetID: any, SusarAssetStatusID: any) {
    let SusarDILID = PersonAssetID;
    this.loaderService.showLoader();
    this.communicationService.getSusarUrl(SusarDILID, true,this.SiteID ).then((result) => {
      if (result.SuccessFlag) {
        let params: IViewerParams = {
          DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
          ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
          DownloadCallbackFunction: "DownloadDocument",
          DownloadCallbackFunctionParam: SusarAssetStatusID,
          Anontation: false,
          Download: true,
          Print: true
        };
        let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
        let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
        //let CONTENTURL = environment.viewerAppUrl + 'viewer/index?' + (result.Type == "URL" ? 'document=' + encodeURIComponent(result.ViewingSessionID) : "viewingsessionid=" + result.ViewingSessionID) + "&dnCallbkFn=DownloadDocument&dnCallbkFnParam=" + SusarAssetStatusID;
        let tabData: ITabs = {
          AssetId: AssetID,
          DocumentType: DocumentType.SafetyReport,
          DocumentPath: result.DocumentPath,
          contentUrl: CONTENTURL,
          htmlContent: "",
          name: Name,
          PersonAssetGuid: '',
          PersonAssetId: 0,
          showPlaceInRegDoc: this.placeInRegDocEnabled,
          showPrintButton: false,
          showSignButton: result.Status.toLowerCase() == 'haselectronicsignature',
          SusarAssetStatusId: SusarAssetStatusID,
          ViewerContentType: ViewerContentType.Document,
          viewerToken: queryParam
        };

        let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
        modalInstance.componentInstance.tabData = tabData;
      } else {
        this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
      }
    }).finally(() => {
      this.loaderService.hideLoader();
    });
  }
  OpenMessage(Name: any, PersonAssetID: any, PersonAssetGuid: any, AssetID: any) {
    this.loaderService.showLoader();
    this.communicationService.getAlertDetails(this.sponsor,this.portalId, PersonAssetGuid).then((result) => {
      if (result) {
        let tabData: ITabs = { AssetId: AssetID, DocumentType: DocumentType.Document, DocumentPath: result.DocumentPath, htmlContent: result.AlertText, name: Name, PersonAssetGuid: PersonAssetGuid, PersonAssetId: PersonAssetID, showPlaceInRegDoc: this.placeInRegDocEnabled, showPrintButton: true, showSignButton: result.Status.toLowerCase() == 'click to sign', SusarAssetStatusId: 0, ViewerContentType: ViewerContentType.HtmlContent };
        let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
        modalInstance.componentInstance.tabData = tabData;
      }
      else {
        this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
        this.loaderService.hideLoader();
      }
    }).finally(() => {
      this.loaderService.hideLoader();
    });
  }
  insertAssetTracking(assetTracking:AssetTracking){
          this.documentService.insertAssetTracking(this.sponsor,assetTracking);
  }
}
